<template>
  <div
    class="modal fade"
    id="add-device-temp-tunnel"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body" v-if="!selectedNetworkDevice.tunnel">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="add-device-temp-tunnel-close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2 text-primary">
              {{ $t("nases.generate_remote_tunnel") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />
          <div class="row g-6">
            <div class="col-12">
              <label class="form-label" for="operationTime">{{
                $t("tunnels.nas")
              }}</label>
              <input
                type="text"
                class="form-control"
                :disabled="selectedNetworkDevice.id"
                :value="selectedNetworkDevice.nas.nasname"
              />
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label" for="operationTime">{{
                $t("network_devices.ip")
              }}</label>
              <input
                type="text"
                class="form-control"
                :disabled="selectedNetworkDevice.id"
                :value="selectedNetworkDevice.ip_address"
              />
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label" for="operationTime">{{
                $t("tunnels.port_to_forward")
              }}</label>
              <select class="form-select" v-model="tunnel.select_port">
                <option value="80">HTTP (80)</option>
                <option value="443">HTTPS (443)</option>
                <option value="8291">Winbox (8291)</option>
                <option value="-1">{{ $t("tunnels.custom_input") }}</option>
              </select>
              <input
                type="number"
                min="10"
                max="65535"
                v-if="tunnel.select_port === '-1'"
                v-model="tunnel.internal_port"
                class="form-control"
                placeholder="10-65535"
              />
            </div>
            <div
              class="col-12 text-danger"
              v-for="(item, index) in server_errors"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
          <div class="row mt-6">
            <div class="flex justify-center">
              <button
                class="btn btn-primary"
                :disabled="
                  loading ||
                    tunnel.internal_port > 65535 ||
                    tunnel.internal_port < 10
                "
                @click="store"
              >
                {{ $t("tunnels.generate_tunnel") }}
              </button>
            </div>
          </div>
        </div>
        <div v-else class="modal-body">
          <LoadingElement v-if="loading" />

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="add-device-temp-tunnel-close"
          ></button>
          <div class="text-center">
            <h4 class="mb-2 text-secondary">
              {{ $t("nases.remote_tunnel") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />
          <div class="flex justify-center my-4">
            <div class="input-group">
              <button
                @click="goToUrl(selectedNetworkDevice.tunnel.url)"
                v-if="selectedNetworkDevice.tunnel.is_url"
                class="btn btn-primary"
              >
                {{ $t("tunnels.go_to_url") }}
              </button>
              <button
                @click="copyToClipboard(selectedNetworkDevice.tunnel.url)"
                v-else
                class="btn btn-primary"
              >
                <i class="ti ti-clipboard"></i>
              </button>
              <input
                type="text"
                class="form-control text-center"
                :value="selectedNetworkDevice.tunnel.url"
              />
            </div>
          </div>
          <div class="flex justify-center">
            <button class="btn btn-danger" @click="remove">
              {{ $t("tunnels.remove_tunnel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "DeviceTunnelAddModal",
  props: {
    nas: {
      type: Object,
      required: false,
    },
    networkdevice: {
      type: Object,
      required: false,
    },
  },
  created() {
    if (this.networkdevice) {
      this.selectedNetworkDevice = this.networkdevice;
    }
  },
  data() {
    return {
      loading: false,
      selectedNetworkDevice: {
        ip: null,
      },
      tunnel: {
        select_port: "80",
        internal_port: 80,
      },
      server_errors: null,
    };
  },
  methods: {
    async store() {
      try {
        if (this.selectedNetworkDevice.id != null) {
          const response = await axios.post("nases/tunnel", {
            nas_id: this.selectedNetworkDevice.nas_id,
            device_ip: this.selectedNetworkDevice.ip_address,
            network_device_id: this.selectedNetworkDevice.id,
            device_port:
              this.tunnel.select_port === "-1"
                ? this.tunnel.internal_port
                : this.tunnel.select_port,
          });
          if (response.status === 200) {
            document.getElementById("add-device-temp-tunnel-close").click();
            this.$notify({
              text: this.$t("tunnels.tunnel_generated_successfully"),
              type: "success",
            });
            this.$emit("updated");
          } else if (response.status == 210) {
            this.$notify({
              text: this.$t("tunnels.tunnel_generate_failed"),
              type: "error",
            });
            this.server_errors = response.data.errors;
            this.validated = false;
          }
        }
      } catch (error) {
        console.log(error);

        this.$notify({
          text: this.$t("tunnels.tunnel_generate_failed"),
          type: "error",
        });
      }
    },

    async remove() {
      if (this.selectedNetworkDevice.id != null) {
        const response = await axios.post("nases/tunnel/remove", {
          tunnel_id: this.selectedNetworkDevice.tunnel.id,
        });
        if (response.status === 200) {
          document.getElementById("add-device-temp-tunnel-close").click();
          this.$notify({
            text: this.$t("tunnels.tunnel_removed_successfully"),
            type: "success",
          });
          this.$emit("updated");
        }
      } else {
        this.$notify({
          text: this.$t("tunnels.tunnel_remove_failed"),
          type: "error",
        });
      }
    },
    goToUrl(url) {
      console.log(url);

      window.open(url, "_blank").focus();
    },
    copyToClipboard(url) {
      // Get the text field
      var copyText = document.createElement("textarea");
      copyText.value = url;
      document.body.appendChild(copyText);
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.value);
      this.$notify({
        text: this.$t("control.copied_to_clipboard"),
        type: "info",
      });
    },
  },
};
</script>
